import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemHeader.css'

/**
 * Item Header spans the full width at the top of an [Item](/components/item/),
 * useful for a leading image or a row of metadata.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the header content.
 */
@customElement('nord-item-header')
export default class ItemHeader extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-header': ItemHeader
  }
}
